import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Configuration } from "src/assets/Configuration";
import { ComplianceCategoryCreationAndUpdateModel } from "../models/compliance/compliance-category-creation-and-update.model";
import { ComplianceCategoryFullModel } from "../models/compliance/compliance-category-full.model";
import { ComplianceCategoryModel } from "../models/compliance/compliance-category.model";
import { ComplianceAssociatedCourseModel } from "../models/compliance/compliance-associated-course.model";
import { ComplianceCourseIddProgressModel } from "../models/compliance/compliance-course-idd-progress.model";
import { ComplianceLocationIddProgressModel } from "../models/compliance/compliance-location-idd-progress.model";
import { ComplianceCategorySummaryWithIddProgressModel } from "../models/compliance/compliance-category-summary-with-idd-progress.model";

@Injectable({
  providedIn: 'root'
})
export class ComplianceCategoryService {

  constructor(private httpClient: HttpClient) {
  }

  public getMyComplianceCategories(): Observable<ComplianceCategoryModel[]> {
    return this.httpClient.get<ComplianceCategoryModel[]>(
      Configuration.getApiBaseUrl() + '/compliancecategory/my'
    );
  }

  public getAllComplianceCategoriesFull(): Observable<ComplianceCategoryFullModel[]> {
    return this.httpClient.get<ComplianceCategoryFullModel[]>(
      Configuration.getApiBaseUrl() + '/compliancecategory/full'
    );
  }

  public getAllComplianceCategories(): Observable<ComplianceCategoryModel[]> {
    return this.httpClient.get<ComplianceCategoryModel[]>(
      Configuration.getApiBaseUrl() + '/compliancecategory/'
    );
  }

  public getUnassignedComplianceCategories(courseId: string | null): Observable<ComplianceCategoryModel[]> {
    let params = new HttpParams();

    if (courseId) {
      params = params.set('courseId', courseId);
    }

    return this.httpClient.get<ComplianceCategoryModel[]>(
      Configuration.getApiBaseUrl() + '/compliancecategory/unassigned',
      { params: params }
    );
  }

  public getMyComplianceCategoriesWithIddProgress(): Observable<ComplianceCategorySummaryWithIddProgressModel[]> {
    return this.httpClient.get<ComplianceCategorySummaryWithIddProgressModel[]>(
      Configuration.getApiBaseUrl() + '/compliancecategory/my/idd-progress'
    );
  }

  public getComplianceCategoryFull(id: string): Observable<ComplianceCategoryFullModel> {
    return this.httpClient.get<ComplianceCategoryFullModel>(
      Configuration.getApiBaseUrl() + '/compliancecategory/' + id + '/full'
    );
  }

  public getComplianceCategory(id: string): Observable<ComplianceCategoryModel> {
    return this.httpClient.get<ComplianceCategoryModel>(
      Configuration.getApiBaseUrl() + '/compliancecategory/' + id
    );
  }

  getComplianceCourseIddProgress(id: string): Observable<ComplianceCourseIddProgressModel> {
    return this.httpClient.get<ComplianceCourseIddProgressModel>(
      Configuration.getApiBaseUrl() + '/compliancecategory/' + id + '/qualification-status-course'
    );  
  }

  getComplianceLocationIddProgress(id: string): Observable<ComplianceLocationIddProgressModel[]> {
    return this.httpClient.get<ComplianceLocationIddProgressModel[]>(
      Configuration.getApiBaseUrl() + '/compliancecategory/' + id + '/qualification-status-location'
    );
  }

  public getComplianceAssociatedCourses(id: string): Observable<ComplianceAssociatedCourseModel[]> {
    return this.httpClient.get<ComplianceAssociatedCourseModel[]>(
      Configuration.getApiBaseUrl() + '/compliancecategory/' + id + '/associated-courses'
    );
  }

  public addComplianceCategory(
    model: ComplianceCategoryCreationAndUpdateModel
  ): Observable<ComplianceCategoryFullModel> {
    return this.httpClient.post<ComplianceCategoryFullModel>(
      Configuration.getApiBaseUrl() + '/compliancecategory/',
      model
    );
  }

  public updateComplianceCategory(
    id: string, model: ComplianceCategoryCreationAndUpdateModel
  ): Observable<ComplianceCategoryFullModel> {
    return this.httpClient.post<ComplianceCategoryFullModel>(
      Configuration.getApiBaseUrl() + '/compliancecategory/' + id,
      model
    );
  }

  public deleteComplianceCategory(id: string): Observable<void> {
    return this.httpClient.delete<void>(
      Configuration.getApiBaseUrl() + '/compliancecategory/' + id
    );
  }
}